<template>
    <v-modal-confirmed accept-button-text="Borrar"
                       close-button-text="Cancelar"
                       title="Borrar letrado"
                       confirm-modal-accept-button-text="Sí"
                       confirm-modal-close-button-text="No"
                       confirm-modal-text="¿Estás seguro?"
                       confirm-modal-title="Confirmar..."
                       @closed="closeModal"
                       @accepted="deleteLawyer">
        <span>¿Seguro que quieres eliminar a este letrado?</span>
        <div class="user-name">{{ lawyer.name + " " + lawyer.surname }}</div>
    </v-modal-confirmed>
</template>

<script>
import VModalConfirmed from "../../general/VModalConfirmed";
import {deleteLawyer} from "../../../helpers/requests/RequestsLawyers";

export default {
    name: "LawyersListDeleteModal",
    components: {VModalConfirmed},
    props: ['lawyer'],
    methods: {
        async deleteLawyer() {
            try {
                await deleteLawyer(this.lawyer);

                this.$store.dispatch('app/setToastMessage', 'Letrado eliminado');

                this.closeModal();

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al eliminar el letrado');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
